import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import axiosInstance from "../../api/axiosInstance";
import { endpoints } from "../../api/endpoints";
import {
  clearAuth,
  setToken,
  setUser,
  setAdminUser,
} from "../../utils/authHelper";

const handleAuthResponse = (data) => {
  if (data.status === 200 && data.data) {
    setToken(data?.data.user_loginauth);
    setUser(data.data);
  }
  let isAdmin = data.data;
  if (isAdmin.user_type === "admin") {
    setAdminUser(isAdmin);
  }
  return data;
};

export const login = createAsyncThunk(
  "auth/login",
  async (loginData, { rejectWithValue }) => {
    try {
      const response = await axiosInstance.post(endpoints.login, loginData);
      sessionStorage.removeItem("slate-token");
      localStorage.removeItem("admin-user");
      localStorage.removeItem("activePath");
      return handleAuthResponse(response.data);
    } catch (error) {
      return rejectWithValue(error.response?.data || error.message);
    }
  }
);
export const registerUser = createAsyncThunk(
  "auth/registerUser",
  async (loginData, { rejectWithValue }) => {
    try {
      const response = await axiosInstance.post(endpoints.signup, loginData);
      return handleAuthResponse(response.data);
    } catch (error) {
      return rejectWithValue(error.response?.data || error.message);
    }
  }
);
export const deleteUserAccount = createAsyncThunk(
  "auth/deleteUserAccount",
  async (loginData, { rejectWithValue }) => {
    try {
      const response = await axiosInstance.post(
        endpoints.deleteaccount,
        loginData
      );
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data || error.message);
    }
  }
);
export const activateUserAccount = createAsyncThunk(
  "auth/activateUserAccount",
  async (loginData, { rejectWithValue }) => {
    try {
      const response = await axiosInstance.post(
        endpoints.activateaccount,
        loginData
      );
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data || error.message);
    }
  }
);
export const verifynewUser = createAsyncThunk(
  "auth/verifynewUser",
  async (loginData, { rejectWithValue }) => {
    try {
      const response = await axiosInstance.post(
        endpoints.verifynewuser,
        loginData
      );
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data || error.message);
    }
  }
);
export const forgetpassword = createAsyncThunk(
  "auth/forgetpassword",
  async (loginData, { rejectWithValue }) => {
    try {
      const response = await axiosInstance.post(
        endpoints.forgetpassword,
        loginData
      );
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data || error.message);
    }
  }
);
export const checkForgetPasswordLink = createAsyncThunk(
  "auth/checkForgetPasswordLink",
  async (loginData, { rejectWithValue }) => {
    try {
      const response = await axiosInstance.post(
        endpoints.checkforgetpasswordlink,
        loginData
      );
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data || error.message);
    }
  }
);
export const getUserDataForSignup = createAsyncThunk(
  "auth/getUserDataForSignup",
  async (id, { rejectWithValue }) => {
    try {
      const response = await axiosInstance.get(
        `${endpoints.getuserinvitationdetails}/${id}`
      );
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data || error.message);
    }
  }
);
export const changeForgetPassword = createAsyncThunk(
  "auth/changeForgetPassword",
  async (loginData, { rejectWithValue }) => {
    try {
      const response = await axiosInstance.post(
        endpoints.setchangepassword,
        loginData
      );
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data || error.message);
    }
  }
);
export const updateUserProfile = createAsyncThunk(
  "auth/updateUserProfile",
  async (loginData, { rejectWithValue }) => {
    try {
      const response = await axiosInstance.post(
        endpoints.edituserprofile,
        loginData
      );
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data || error.message);
    }
  }
);
export const SendInvitesforClientRecruter = createAsyncThunk(
  "auth/SendInvitesforClientRecruter",
  async (loginData, { rejectWithValue }) => {
    try {
      const response = await axiosInstance.post(
        endpoints.userinvitation,
        loginData
      );
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data || error.message);
    }
  }
);
export const changePassword = createAsyncThunk(
  "auth/changePassword",
  async (loginData, { rejectWithValue }) => {
    try {
      const response = await axiosInstance.post(
        endpoints.changepassword,
        loginData
      );
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data || error.message);
    }
  }
);
export const verifyNewUserForEdit = createAsyncThunk(
  "auth/verifyNewUserForEdit",
  async (loginData, { rejectWithValue }) => {
    try {
      const response = await axiosInstance.post(
        endpoints.verifynewusermasterforedit,
        loginData
      );
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data || error.message);
    }
  }
);
export const updateEmailForUser = createAsyncThunk(
  "auth/updateEmailForUser",
  async (loginData, { rejectWithValue }) => {
    try {
      const response = await axiosInstance.post(
        endpoints.updateemailforuser,
        loginData
      );
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data || error.message);
    }
  }
);

export const fetchUserData = createAsyncThunk(
  "auth/fetchUserData",
  async (userId, { rejectWithValue }) => {
    try {
      const response = await axiosInstance.get(
        `${endpoints.getusermaster}${userId}`
      );
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data || "Something went wrong");
    }
  }
);

const createAsyncReducers = (builder, thunkAction) => {
  builder
    .addCase(thunkAction.pending, (state) => {
      state.loading = true;
      state.error = null;
    })
    .addCase(thunkAction.fulfilled, (state, action) => {
      state.loading = false;
      state.error = null;
      if (
        thunkAction === login ||
        thunkAction === registerUser ||
        thunkAction === checkForgetPasswordLink ||
        thunkAction === fetchUserData
      ) {
        state.user = action.payload.data;
      } else if (thunkAction === verifynewUser) {
        state.activateuser = action.payload;
      } else if (thunkAction === getUserDataForSignup) {
        state.userInvitationData = action.payload.data;
      }
    })
    .addCase(thunkAction.rejected, (state, action) => {
      state.loading = false;
      state.error = action.payload || action.error.message;
    });
};

const initialState = {
  user: null,
  activateuser: null,
  signupUser: null,
  userInvitationData: null,
  token: "",
  userData: null,
  loading: false,
  error: null,
};
const authSlice = createSlice({
  name: "auth",
  initialState,
  reducers: {
    logout(state) {
      state.user = null;
      state.userData = null;
      state.activateuser = null;
      clearAuth();
    },
    resetUserDataForSignup(state) {
      state.userInvitationData = null;
    },
  },
  extraReducers: (builder) => {
    createAsyncReducers(builder, login);
    createAsyncReducers(builder, getUserDataForSignup);
    createAsyncReducers(builder, registerUser);
    createAsyncReducers(builder, deleteUserAccount);
    createAsyncReducers(builder, verifynewUser);
    createAsyncReducers(builder, forgetpassword);
    createAsyncReducers(builder, checkForgetPasswordLink);
    createAsyncReducers(builder, changeForgetPassword);
    createAsyncReducers(builder, updateUserProfile);
    createAsyncReducers(builder, changePassword);
    createAsyncReducers(builder, verifyNewUserForEdit);
    createAsyncReducers(builder, updateEmailForUser);
    createAsyncReducers(builder, fetchUserData);
  },
});

export const { logout, resetUserDataForSignup } = authSlice.actions;
export default authSlice.reducer;
